const storeInfo = [
  { icon: 'ri-map-pin-2-line', label: '門市地址', value: '台中市西區精誠路 168 號（近科博館）' },
  { icon: 'ri-time-line', label: '營業時間', value: '週一至週五 11:00–21:00\n週六、週日 10:00–22:00' },
  { icon: 'ri-phone-line', label: '門市電話', value: '(04) 2320-8888' },
  { icon: 'ri-mail-line', label: '電子信箱', value: 'hello@outlet-taichung.com' },
  { icon: 'ri-instagram-line', label: 'Instagram', value: '@outlet.taichung' },
  { icon: 'ri-chat-smile-2-line', label: 'LINE 官方帳號', value: '@outletTC' },
];

export default function StoreLocation() {
  return (
    <section className="bg-[#1E1610] py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="font-sans text-[1rem] text-[#E8D09A]/70 tracking-widest mb-3 font-light">FIND US</p>
          <h2 className="font-serif text-[1.5rem] md:text-[2.125rem] text-white font-semibold leading-[1.4]">
            台中旗艦門市
          </h2>
          <p className="font-sans text-[1.1875rem] text-white/55 leading-[1.75] mt-4 max-w-lg mx-auto">
            歡迎親臨門市，實際感受每件服飾的質感，讓我們的造型顧問為妳服務
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10">
          {/* Map */}
          <div className="flex-1 w-full min-h-[380px] rounded-2xl overflow-hidden border border-white/10">
            <iframe
              title="台中旗艦門市位置"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.1!2d120.6478!3d24.1568!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346916c917a3d2f5%3A0x57a10b6f9db97c28!2z5Y-w5Lit5b-D56CU5boI!5e0!3m2!1szh-TW!2stw!4v1234567890"
              width="100%"
              height="100%"
              style={{ minHeight: '380px', border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Store Info */}
          <div className="flex-shrink-0 w-full lg:w-[360px] flex flex-col gap-5">
            {storeInfo.map((info) => (
              <div key={info.label} className="flex items-start gap-4 bg-white/6 border border-white/10 rounded-xl px-5 py-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#C49A3E]/20 rounded-lg flex-shrink-0 mt-0.5">
                  <i className={`${info.icon} text-[#E8D09A] text-lg`}></i>
                </div>
                <div>
                  <p className="font-sans text-[1rem] text-white/50 mb-0.5">{info.label}</p>
                  <p className="font-sans text-[1.0625rem] text-white font-medium leading-[1.65] whitespace-pre-line">{info.value}</p>
                </div>
              </div>
            ))}

            {/* CTA Button */}
            <a
              href="https://maps.google.com/?q=台中市西區精誠路168號"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="whitespace-nowrap mt-2 w-full text-center font-sans text-[1.0625rem] font-medium bg-white text-[#2C2118] py-3.5 rounded-full hover:bg-[#FAF5EB] transition-all duration-300 cursor-pointer block"
            >
              <i className="ri-navigation-line mr-2"></i>
              開啟 Google 地圖導航
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
